import React, { createContext, useContext } from "react";

export default function contextCreator(reducer, initialState, middlewareFns) {
  const defaultDispatch = () => initialState;
  const stateContext = createContext(initialState);
  const dispatchContext = createContext(defaultDispatch);

  function useStateContext(property = null) {
    const state = useContext(stateContext);
    return property ? state[property] : state;
  }

  function useDispatchContext() {
    return useContext(dispatchContext);
  }

  // eslint-disable-next-line react/prop-types
  function Provider({ children, value }) {
    const initState = { ...initialState, ...value };
    const [state, dispatch] = React.useReducer(reducer, initState);

    const dispatchWithMiddleware = React.useCallback(
      (action) => {
        middlewareFns?.forEach((middlewareFn) => middlewareFn(action));
        dispatch(action);
      },
      [dispatch, middlewareFns]
    );

    return (
      <stateContext.Provider value={state}>
        <dispatchContext.Provider value={dispatchWithMiddleware}>
          {children}
        </dispatchContext.Provider>
      </stateContext.Provider>
    );
  }

  return [useStateContext, useDispatchContext, Provider];
}
